<template>

  <!-- Empty Status -->
  <div
    class="empty-status"
    :class="[`size-${size}`]">

    <!-- Wrapper -->
    <div
      class="empty-status__wrapper"
      :class="[`bg-${color}`, `text-${textColor}`]">

      <span
        style="opacity: .7;">
        {{ message }}
      </span>

      <q-inner-loading
        :showing="loading">

        <q-spinner
          size="3em"
          :thickness="2"
          color="primary"/>

      </q-inner-loading>

    </div>

  </div>

</template>

<script>

  export default {
    name: 'empty-status',
    props: {
      message: {
        type: String,
        default: 'тут ничего',
      },
      size: {
        type: String,
        default: 'md',
      },
      color: {
        type: String,
        default: 'white',
      },
      textColor: {
        type: String,
        default: 'grey',
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
  };

</script>

<style lang="scss">

  .empty-status {

    &__wrapper {
      width: 9em;
      height: 9em;
      padding: 1em;
      display: flex;
      font-size: .5em;
      overflow: hidden;
      margin-left: auto;
      position: relative;
      margin-right: auto;
      border-radius: 50%;
      text-align: center;
      align-items: center;
      justify-content: center;
    }

    .q-inner-loading {
      background: white;
    }
  }

</style>
